<template>
  <div class="shuqi" id="shuqi">
    <img class="imgRender" :src="backUrl" alt="图片">
  </div>
</template>
<script>
export default {
  name: "shuqi",
  data() {
    return {
      msg: "shuqi page",
      backUrl: "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/2024-02-20/mfsx.jpg",
      imgList: [
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_01.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_02.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_03.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12-17.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_08.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_09.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_10.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12_11.jpg'
        },
        {
          src: 'https://ytk-front.oss-cn-beijing.aliyuncs.com/pc/yuanda-m/12-17.jpg'
        },
      ]
    };
  },
  methods:{
    service(i){
      if (i === 1 || i === 8 || i === 3){
        _MEIQIA('showPanel')
      }
    }
  }
};
</script>
<style lang="less" scoped>
  .shuqi{
    font-size: 0;
    .imgRender{
      width: 100%;height: 100%;
    }
    .imgRender:nth-child(4){
      margin-bottom: 10px;
    }
  }
</style>

